new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: '',

        desktop: window.innerWidth <= 991 ? false : true,
    },
    created() {
        addEventListener("resize", (event) => {
            this.desktop = window.innerWidth <= 991 ? false : true;
        });
        const label = document.querySelector('.product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }
    },
    methods: {

        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
                .then(res => {
                    const actualElement = event.target;
                    if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                        $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                    }
                    actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);
                    actualElement.closest('.product-item-kit').querySelector('.is-selected').classList.remove('is-selected');
                    actualElement.closest('.product__colors-item').classList.add('is-selected');
                    actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                    actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                    const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                    actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                    var sizes = [];
                    for (i = 0; i <= res.data.variations.length - 1; i++) {
                        if (res.data.variations[i].main_attribute != null) {
                            sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                        }
                    }
                    for (i = 0; i <= sizes.length - 1; i++) {
                        if (sizes[i].main_attribute != null) {
                            var randomNumber = Math.floor(Math.random() * 99999999);
                            var stock = sizes[i].available == false ? 'out-of-stock' : '';
                            actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail__${res.data.id}_${randomNumber}" id="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                        }
                    }
                    if (res.data.addons.length) {
                        var complements = document.createElement('div');
                        complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
                        complements.setAttribute('class', 'complements');
                        complements.setAttribute('complements-for', `${id}`);
                        complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                        for (i = 0; i <= res.data.addons.length - 1; i++) {
                            var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                            var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                            complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                            if (res.data.addons[i].field_type == "radio_options") {
                                var complementsSelect = document.createElement('select');
                                complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                                complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                                for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                    complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                                }
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content');
                                $(selectDiv).append(complementsSelect);
                                $(complements).append(selectDiv);
                            } else if (res.data.addons[i].field_type == "text") {
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content-area');
                                $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                                $(complements).append(selectDiv);
                            }
                        }
                        $('.kitcolors').closest('.itens-for-carousel').append(complements);
                    }
                    $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function () {
                        $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);
                    });
                    if (window.outerWidth <= 991) {
                        var slickSlider = $('.product-detail__header--photoArea-mobile');

                        if (slickSlider.hasClass('slick-initialized')) {
                            slickSlider.slick('slickRemove', null, null, true);
                        } else {
                            slickSlider.slick();
                        }

                        for (i = 0; i < res.data.images.length; i++) {
                            slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-gallery="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                        }

                        slickSlider.slick('slickGoTo', 1);
                    } else {
                        const noThumbs = document.querySelector('#product-photo');
                        if (noThumbs) {
                            var noThumbsUl = document.querySelector('#product-photo ul');

                            // Remova todos os spans dentro do noThumbsUl
                            while (noThumbsUl.firstChild) {
                                noThumbsUl.removeChild(noThumbsUl.firstChild);
                            }

                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                var li = document.createElement('li');
                                li.innerHTML = `<a href="${res.data.images[i]}" data-gallery="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                                noThumbsUl.appendChild(li);
                            }
                        } else {
                            $('.sp-wrap').each(function () {
                                $(this).closest('.slick-slide').remove();
                            });
                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                                if (i == 0) {
                                    document.querySelector('.sp-wrap').click();
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },

        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        toggleShare(element) {
            element.target.classList.toggle('active');
            element.target.nextElementSibling.classList.toggle('active');
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {

        const withoutStock = document.getElementById('js-produto_sell_without_stock__product_detail_');
        if (withoutStock) {
            withoutStock.style.display = 'none';
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    const targetNode = document.querySelector('#js_shipping_calculation_table');

    if (targetNode) {
        const processRows = () => {
            const rows = targetNode.querySelectorAll('tbody tr');

            rows.forEach(row => {
                const lineThrough = document.querySelector('.product-detail__table__column .value-line-through');
                const span = lineThrough?.nextElementSibling;

                if (lineThrough && span && span.textContent.trim() === 'R$ 0.00') {
                    span.textContent = 'Frete Grátis'; // Troca o texto primeiro
                    lineThrough.remove(); // Depois remove o .value-line-through
                }
            });
        };

        // Executa na primeira carga
        processRows();

        // Observa mudanças dinâmicas
        const observer = new MutationObserver(processRows);
        observer.observe(targetNode, {
            childList: true,
            subtree: true
        });
    }

    waitForElementToExist('.product__colors.attribute').then(element => {
        $('.product__colors.attribute').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 5,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 7,
                    }
                },
            ]
        });
    });




    const allSizesLabel = document.querySelectorAll('label[for^="product_item_variation__product_detail__');
    if (allSizesLabel) {
        allSizesLabel.forEach(label => {
            label.addEventListener('click', () => {
                const inputId = label.getAttribute('for');
                if (inputId) {
                    const container = document.querySelector('.product-detail__fixed--buy');
                    if (container) {
                        const inputsInContainer = container.querySelectorAll('input.clicou');
                        inputsInContainer.forEach(input => {
                            input.classList.remove('clicou');
                        });
                    }

                    const allInputs = document.querySelectorAll(`input[id^="${inputId}"]`);

                    if (allInputs) {
                        allInputs.forEach(input => {
                            input.classList.add('clicou');
                        })
                    }

                }
            });
        })
    }



    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#photo-list').slick({
        slidesToShow: 4,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: false,
        speed: 700,
        vertical: true,
        appendArrows: ".product-detail__showcase--controls-slick",
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    $('.product-detail__resume-description--content-slick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    $('.product-detail__related--items').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        appendArrows: $('.relared-arrows'),
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                }
            },
        ]
    })

    if (document.querySelector(".carousel-kit")) {
        const fixedBuy = document.querySelector('.product-detail__fixed--buy');
        if (fixedBuy) {
            fixedBuy.remove();
        }
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            height: "auto",
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
            addToCartButton.classList.add('no-buy');

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                    if (actual === end) {
                        addToCartButton.classList.remove('no-buy');
                        nextButton.classList.add('no-click');
                    }
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                if (actual === end) {
                    nextButton.classList.remove('no-click');
                }
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    // let rotationDescription = document.querySelector('.product-detail__description');
    // let rotationDescriptionNames = rotationDescription.querySelectorAll('.product-detail__description--names-item');
    // let initDescription = rotationDescription.querySelectorAll('.product-detail__description--descriptions-item');
    // initDescription = Array.from(initDescription);

    // if(rotationDescription && rotationDescriptionNames.length && initDescription.length) {
    //     initDescription[0].classList.add('active');
    //     rotationDescriptionNames[0].classList.add('active');

    //     function activeTab(index) {
    //         initDescription.forEach((content) => {
    //             content.classList.remove('active');
    //         });
    //         rotationDescriptionNames.forEach((content) => {
    //             content.classList.remove('active');
    //         });
    //         initDescription[index].classList.add('active');
    //         rotationDescriptionNames[index].classList.add('active');
    //     }

    //     rotationDescriptionNames.forEach((itemMenu, index) => {
    //         itemMenu.addEventListener('click', (e) => {
    //             e.preventDefault();
    //             activeTab(index);
    //         });
    //     })
    // }

    const brinde = document.querySelector('.product-detail__brinde');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                const noBefore = widget.querySelector('.label-content');
                                if (noBefore) {
                                    widget.classList.add('no-before');
                                } else if (sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }
                            } else if (!sizes) {
                                widget.classList.add('no-before');
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                const noBefore = widget.querySelector('.label-content');
                                if (noBefore) {
                                    widget.classList.add('no-before');
                                } else if (sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }
                            } else if (!sizes) {
                                widget.classList.add('no-before');
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    // const buyTogether = document.querySelector('.product-detail__buy-together');

    // if (buyTogether) {
    //     const observer = new MutationObserver(mutations => {
    //         mutations.forEach(mutation => {
    //             mutation.addedNodes.forEach(node => {
    //                 if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
    //                     if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
    //                         const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
    //                         const options = targetNode.querySelector('.product-item__options');
    //                         const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

    //                         if (options && figcaption) {
    //                             figcaption.insertAdjacentElement('afterend', options);
    //                         }

    //                         const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
    //                         const sizes = targetNode.querySelector('.product-radio-variation');

    //                         if (widget && sizes) {
    //                             widget.addEventListener('click', () => {
    //                                 sizes.classList.toggle('active');
    //                             });

    //                             const allSizes = sizes.querySelectorAll('label');
    //                             allSizes.forEach(size => {
    //                                 size.addEventListener('click', () => {
    //                                     sizes.classList.toggle('active');
    //                                     widget.setAttribute('data-before', size.textContent);
    //                                 });
    //                             });
    //                         }else if (!sizes && widget) {
    //                             widget.classList.add('no-before')
    //                         }
    //                     }
    //                     if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
    //                         const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
    //                         const options = targetNode.querySelector('.product-item__options');
    //                         const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

    //                         if (options && figcaption) {
    //                             figcaption.insertAdjacentElement('afterend', options);
    //                         }

    //                         const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
    //                         const sizes = targetNode.querySelector('.product-radio-variation');

    //                         if (widget && sizes) {
    //                             widget.addEventListener('click', () => {
    //                                 sizes.classList.toggle('active');
    //                             });

    //                             const allSizes = sizes.querySelectorAll('label');
    //                             allSizes.forEach(size => {
    //                                 size.addEventListener('click', () => {
    //                                     sizes.classList.toggle('active');
    //                                     widget.setAttribute('data-before', size.textContent);
    //                                 });
    //                             });
    //                         }else if (!sizes && widget) {
    //                             widget.classList.add('no-before')
    //                         }
    //                     }
    //                     if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
    //                         const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
    //                         const options = targetNode.querySelector('.product-item__options');
    //                         const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

    //                         if (options && figcaption) {
    //                             figcaption.insertAdjacentElement('afterend', options);
    //                         }

    //                         const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
    //                         const sizes = targetNode.querySelector('.product-radio-variation');

    //                         if (widget && sizes) {
    //                             widget.addEventListener('click', () => {
    //                                 sizes.classList.toggle('active');
    //                             });

    //                             const allSizes = sizes.querySelectorAll('label');
    //                             allSizes.forEach(size => {
    //                                 size.addEventListener('click', () => {
    //                                     sizes.classList.toggle('active');
    //                                     widget.setAttribute('data-before', size.textContent);
    //                                 });
    //                             });
    //                         }else if (!sizes && widget) {
    //                             widget.classList.add('no-before')
    //                         }
    //                     }
    //                 }
    //             });
    //         });
    //     });

    //     observer.observe(buyTogether, {
    //         childList: true,
    //         subtree: true
    //     });

    // }



})
/**
 * Modal da galeria de fotos do produto.
 * Substitui o fancybox, que escrevia hash na URL e quebrava a navegação.
 * Os links da galeria usam data-gallery="nome-do-grupo".
 */
;(function () {
    const YOUTUBE_REGEX = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
    const VIDEO_REGEX = /\.(mp4|webm|ogg|mov)(\?.*)?$/i;

    let modal = null;
    let slider = null;
    let counter = null;
    let prevArrow = null;
    let nextArrow = null;
    let zoomButton = null;

    // ampliação da foto no zoom (o fancybox fazia isso e se perdeu na troca)
    const ZOOM_SCALE = 2.5;

    // no mobile o zoom é a pinça com dois dedos (e o toque duplo) aplicada só na foto:
    // o zoom nativo do navegador ampliaria a tela inteira, com fundo, contador e botões
    const MOBILE_QUERY = window.matchMedia('(max-width: 991px)');
    const PINCH_MAX = 4;
    const DOUBLE_TAP_MS = 300;
    const TAP_TOLERANCE = 10;
    // gestos de fechar no mobile: arrastar a foto para cima/baixo além disso,
    // ou fechar a pinça até a foto ficar menor que isso
    const DISMISS_DISTANCE = 120;
    const PINCH_CLOSE = 0.8;
    const PINCH_MIN = 0.5;

    // estado da pinça na foto atual; x/y = deslocamento em px, scale = ampliação
    const pinch = {
        img: null, mode: null, scale: 1, x: 0, y: 0,
        startScale: 1, startDistance: 0, anchorX: 0, anchorY: 0,
        startX: 0, startY: 0, panX: 0, panY: 0, moved: false, lastTap: 0,
        directionChecked: false
    };
    let backdrop = null;

    function youtubeSlide(id) {
        return `<div class="gallery-modal__slide"><iframe src="https://www.youtube.com/embed/${id}?rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    }

    function videoSlide(src) {
        return `<div class="gallery-modal__slide"><video controls playsinline><source src="${src}"></video></div>`;
    }

    function buildSlide(item) {
        const src = item.src;

        // no cadastro do YouTube o campo guarda só o ID, não a URL completa
        if (item.type === 'youtube') {
            const match = src.match(YOUTUBE_REGEX);
            return youtubeSlide(match ? match[1] : src);
        }

        if (item.type === 'video') return videoSlide(src);

        const youtube = src.match(YOUTUBE_REGEX);
        if (youtube) return youtubeSlide(youtube[1]);

        if (VIDEO_REGEX.test(src)) return videoSlide(src);

        return `<div class="gallery-modal__slide"><img src="${src}" alt=""></div>`;
    }

    function buildModal() {
        modal = document.createElement('div');
        modal.className = 'gallery-modal';
        modal.innerHTML = `
            <div class="gallery-modal__backdrop" data-gallery-close></div>
            <div class="gallery-modal__content">
                <span class="gallery-modal__counter"></span>
                <button type="button" class="gallery-modal__zoom" aria-label="Ampliar" aria-pressed="false">
                    <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4M8 11h6"/><path class="gallery-modal__zoom-plus" d="M11 8v6"/></svg>
                </button>
                <button type="button" class="gallery-modal__close" aria-label="Fechar" data-gallery-close>
                    <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
                </button>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--prev" aria-label="Anterior">
                    <svg viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>
                </button>
                <div class="gallery-modal__slider"></div>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--next" aria-label="Próximo">
                    <svg viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>
                </button>
            </div>
        `;
        document.body.appendChild(modal);

        slider = modal.querySelector('.gallery-modal__slider');
        counter = modal.querySelector('.gallery-modal__counter');
        prevArrow = modal.querySelector('.gallery-modal__arrow--prev');
        nextArrow = modal.querySelector('.gallery-modal__arrow--next');
        zoomButton = modal.querySelector('.gallery-modal__zoom');
        backdrop = modal.querySelector('.gallery-modal__backdrop');

        zoomButton.addEventListener('click', function () {
            if (modal.classList.contains('is-zoomed')) {
                zoomOut();
            } else {
                zoomIn();
            }
        });

        // clicar na própria foto também amplia/reduz, como no fancybox (só desktop)
        slider.addEventListener('click', function (e) {
            if (MOBILE_QUERY.matches) return;

            const img = e.target.closest('img');
            if (!img || img !== currentImage()) return;

            if (modal.classList.contains('is-zoomed')) {
                zoomOut();
            } else {
                zoomIn(e.clientX, e.clientY);
            }
        });

        // pinça do mobile: captura antes do slick, para os dedos na foto ampliada
        // não virarem swipe de slide
        slider.addEventListener('touchstart', onTouchStart, { capture: true, passive: false });
        slider.addEventListener('touchmove', onTouchMove, { capture: true, passive: false });
        slider.addEventListener('touchend', onTouchEnd, { capture: true });
        slider.addEventListener('touchcancel', onTouchEnd, { capture: true });

        // com zoom, o ponto ampliado acompanha o mouse/dedo
        slider.addEventListener('mousemove', function (e) {
            if (modal.classList.contains('is-zoomed')) moveZoom(e.clientX, e.clientY);
        });

        slider.addEventListener('touchmove', function (e) {
            if (!modal.classList.contains('is-zoomed')) return;
            e.preventDefault();
            moveZoom(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: false });

        modal.addEventListener('click', function (e) {
            if (e.target.closest('[data-gallery-close]')) {
                closeModal();
                return;
            }

            // desktop: clique no fundo, fora da foto/vídeo e dos botões, fecha o modal
            // (o slide ocupa a tela toda, então o clique quase nunca chega no backdrop)
            if (!MOBILE_QUERY.matches && !e.target.closest('img, video, iframe, button')) {
                closeModal();
            }
        });

        prevArrow.addEventListener('click', () => $(slider).slick('slickPrev'));
        nextArrow.addEventListener('click', () => $(slider).slick('slickNext'));

        document.addEventListener('keydown', function (e) {
            if (!modal.classList.contains('is-open')) return;

            if (e.key === 'Escape') closeModal();
            if (e.key === 'ArrowLeft') $(slider).slick('slickPrev');
            if (e.key === 'ArrowRight') $(slider).slick('slickNext');
        });
    }

    function setSwipe(enabled) {
        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('slickSetOption', 'swipe', enabled, false);
        }
    }

    function touchDistance(touches) {
        return Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
    }

    function touchCenter(touches) {
        return {
            x: (touches[0].clientX + touches[1].clientX) / 2,
            y: (touches[0].clientY + touches[1].clientY) / 2
        };
    }

    // centro da foto na tela sem a transformação (a foto fica centralizada no slide)
    function imageCenter(img) {
        const rect = img.parentElement.getBoundingClientRect();
        return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    }

    // tamanho da foto desenhada: com object-fit: contain a caixa da img tem sobra
    function visibleSize(img) {
        const boxWidth = img.offsetWidth;
        const boxHeight = img.offsetHeight;
        const ratio = img.naturalWidth / img.naturalHeight || boxWidth / boxHeight;

        if (boxWidth / boxHeight > ratio) return { width: boxHeight * ratio, height: boxHeight };
        return { width: boxWidth, height: boxWidth / ratio };
    }

    // amplia mantendo embaixo do dedo o mesmo ponto da foto
    function zoomAt(scale, clientX, clientY) {
        const center = imageCenter(pinch.img);
        const pointX = (clientX - center.x - pinch.x) / pinch.scale;
        const pointY = (clientY - center.y - pinch.y) / pinch.scale;

        pinch.scale = scale;
        pinch.x = clientX - center.x - scale * pointX;
        pinch.y = clientY - center.y - scale * pointY;
    }

    function applyPinch(animate) {
        const img = pinch.img;
        if (!img) return;

        // não deixa a foto sair da tela: só desloca o que passou da borda
        const size = visibleSize(img);
        const slide = img.parentElement;
        const limitX = Math.max((size.width * pinch.scale - slide.offsetWidth) / 2, 0);
        const limitY = Math.max((size.height * pinch.scale - slide.offsetHeight) / 2, 0);

        pinch.x = Math.min(Math.max(pinch.x, -limitX), limitX);
        pinch.y = Math.min(Math.max(pinch.y, -limitY), limitY);

        img.style.transition = animate ? 'transform .25s ease' : 'none';
        img.style.transform = `translate(${pinch.x}px, ${pinch.y}px) scale(${pinch.scale})`;
    }

    function resetPinch() {
        if (pinch.img) {
            pinch.img.style.transform = '';
            pinch.img.style.transition = '';
        }

        pinch.img = null;
        pinch.mode = null;
        pinch.scale = 1;
        pinch.x = 0;
        pinch.y = 0;

        modal.classList.remove('is-pinched');
        setBackdropOpacity('', false);
        setSwipe(true);
    }

    // o fundo clareia enquanto o gesto de fechar acontece
    function setBackdropOpacity(opacity, animate) {
        if (!backdrop) return;
        backdrop.style.transition = animate ? 'opacity .25s ease' : 'none';
        backdrop.style.opacity = opacity;
    }

    function onTouchStart(e) {
        if (!MOBILE_QUERY.matches) return;

        const img = currentImage();
        if (!img || !e.target.closest('.slick-current')) return;

        if (pinch.img !== img) {
            resetPinch();
            pinch.img = img;
        }

        if (e.touches.length === 2) {
            e.preventDefault();
            e.stopPropagation();

            const center = touchCenter(e.touches);
            const imgCenter = imageCenter(img);

            pinch.mode = 'pinch';
            pinch.moved = true;
            pinch.startScale = pinch.scale;
            pinch.startDistance = touchDistance(e.touches);
            pinch.anchorX = (center.x - imgCenter.x - pinch.x) / pinch.scale;
            pinch.anchorY = (center.y - imgCenter.y - pinch.y) / pinch.scale;
            setSwipe(false);
            return;
        }

        if (e.touches.length !== 1) return;

        pinch.moved = false;
        pinch.directionChecked = false;
        pinch.startX = e.touches[0].clientX;
        pinch.startY = e.touches[0].clientY;
        pinch.panX = pinch.x;
        pinch.panY = pinch.y;

        // foto ampliada: um dedo passeia pela foto em vez de trocar de slide
        if (pinch.scale > 1) {
            pinch.mode = 'pan';
            e.stopPropagation();
        } else {
            pinch.mode = null;
        }
    }

    function onTouchMove(e) {
        if (!MOBILE_QUERY.matches || !pinch.img) return;

        if (pinch.mode === 'pinch' && e.touches.length === 2) {
            e.preventDefault();
            e.stopPropagation();

            const center = touchCenter(e.touches);
            const imgCenter = imageCenter(pinch.img);
            const scale = pinch.startScale * touchDistance(e.touches) / pinch.startDistance;

            // abaixo de 1 é o gesto de fechar: a foto encolhe e o fundo clareia junto
            pinch.scale = Math.min(Math.max(scale, PINCH_MIN), PINCH_MAX);
            pinch.x = center.x - imgCenter.x - pinch.scale * pinch.anchorX;
            pinch.y = center.y - imgCenter.y - pinch.scale * pinch.anchorY;
            applyPinch(false);
            setBackdropOpacity(pinch.scale < 1 ? pinch.scale : '', false);
            return;
        }

        if (e.touches.length !== 1) return;

        const deltaX = e.touches[0].clientX - pinch.startX;
        const deltaY = e.touches[0].clientY - pinch.startY;
        if (Math.abs(deltaX) > TAP_TOLERANCE || Math.abs(deltaY) > TAP_TOLERANCE) pinch.moved = true;

        // foto no tamanho normal: movimento mais vertical que horizontal é o gesto de
        // fechar; horizontal continua sendo o swipe do slick
        if (pinch.mode === null && pinch.moved && !pinch.directionChecked) {
            pinch.directionChecked = true;
            if (Math.abs(deltaY) > Math.abs(deltaX)) pinch.mode = 'dismiss';
        }

        if (pinch.mode === 'dismiss') {
            e.preventDefault();
            e.stopPropagation();

            pinch.img.style.transition = 'none';
            pinch.img.style.transform = `translateY(${deltaY}px)`;
            setBackdropOpacity(Math.max(1 - Math.abs(deltaY) / (window.innerHeight / 2), 0.2), false);
            return;
        }

        if (pinch.mode === 'pan') {
            e.preventDefault();
            e.stopPropagation();

            pinch.x = pinch.panX + deltaX;
            pinch.y = pinch.panY + deltaY;
            applyPinch(false);
        }
    }

    function onTouchEnd(e) {
        if (!MOBILE_QUERY.matches || !pinch.img) return;

        // soltou um dos dois dedos: o que ficou continua arrastando a foto ampliada
        if (pinch.mode === 'pinch' && e.touches.length === 1) {
            pinch.mode = pinch.scale > 1 ? 'pan' : null;
            // o dedo que sobrou da pinça não vale como gesto de arrastar para fechar
            pinch.directionChecked = true;
            pinch.startX = e.touches[0].clientX;
            pinch.startY = e.touches[0].clientY;
            pinch.panX = pinch.x;
            pinch.panY = pinch.y;
            return;
        }

        if (e.touches.length) return;

        if (pinch.mode === 'dismiss') {
            const deltaY = e.changedTouches[0].clientY - pinch.startY;

            if (Math.abs(deltaY) > DISMISS_DISTANCE) {
                // sem isso o clique "fantasma" do toque cai na página atrás do modal
                e.preventDefault();
                closeModal();
                return;
            }

            // não arrastou o bastante: a foto volta para o lugar
            pinch.img.style.transition = 'transform .25s ease';
            pinch.img.style.transform = '';
            setBackdropOpacity('', true);
            pinch.mode = null;
            return;
        }

        // pinça fechada até a foto encolher: fecha o modal
        if (pinch.scale < PINCH_CLOSE) {
            e.preventDefault();
            closeModal();
            return;
        }

        // toque duplo: amplia no ponto tocado ou volta ao tamanho normal
        if (!pinch.moved) {
            const now = Date.now();

            if (now - pinch.lastTap < DOUBLE_TAP_MS) {
                const touch = e.changedTouches[0];

                if (pinch.scale > 1) {
                    pinch.scale = 1;
                    pinch.x = 0;
                    pinch.y = 0;
                } else {
                    zoomAt(ZOOM_SCALE, touch.clientX, touch.clientY);
                }

                applyPinch(true);
                pinch.lastTap = 0;
            } else {
                pinch.lastTap = now;
            }
        }

        if (pinch.scale <= 1.01) {
            pinch.scale = 1;
            pinch.x = 0;
            pinch.y = 0;
            applyPinch(true);
            setBackdropOpacity('', true);
        }

        const zoomed = pinch.scale > 1;
        modal.classList.toggle('is-pinched', zoomed);
        setSwipe(!zoomed);
        pinch.mode = null;
    }

    function currentImage() {
        return slider.querySelector('.slick-current img');
    }

    function moveZoom(clientX, clientY) {
        const img = currentImage();
        if (!img) return;

        // posição relativa à foto sem a escala (o getBoundingClientRect já viria ampliado)
        const slideRect = img.parentElement.getBoundingClientRect();
        const x = (clientX - slideRect.left - img.offsetLeft) / img.offsetWidth;
        const y = (clientY - slideRect.top - img.offsetTop) / img.offsetHeight;
        const clamp = value => Math.min(Math.max(value, 0), 1) * 100;

        img.style.transformOrigin = `${clamp(x)}% ${clamp(y)}%`;
    }

    function zoomIn(clientX, clientY) {
        const img = currentImage();
        if (!img) return;

        modal.classList.add('is-zoomed');
        zoomButton.setAttribute('aria-pressed', 'true');
        zoomButton.setAttribute('aria-label', 'Reduzir');

        if (clientX === undefined) {
            img.style.transformOrigin = '50% 50%';
        } else {
            moveZoom(clientX, clientY);
        }
        img.style.transform = `scale(${ZOOM_SCALE})`;

        // sem isso o arrastar para ver a foto ampliada trocaria de slide
        $(slider).slick('slickSetOption', 'swipe', false, false);
        $(slider).slick('slickSetOption', 'draggable', false, false);
    }

    function zoomOut() {
        if (!modal || !modal.classList.contains('is-zoomed')) return;

        modal.classList.remove('is-zoomed');
        zoomButton.setAttribute('aria-pressed', 'false');
        zoomButton.setAttribute('aria-label', 'Ampliar');

        slider.querySelectorAll('img').forEach(img => {
            img.style.transform = '';
            img.style.transformOrigin = '';
        });

        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('slickSetOption', 'swipe', true, false);
            $(slider).slick('slickSetOption', 'draggable', true, false);
        }
    }

    function updateStatus(current, total) {
        counter.textContent = `${current + 1} / ${total}`;
        prevArrow.disabled = current === 0;
        nextArrow.disabled = current === total - 1;
        // vídeo não tem zoom
        zoomButton.hidden = !currentImage();
    }

    function openModal(items, index) {
        if (!modal) buildModal();

        slider.innerHTML = items.map(buildSlide).join('');

        modal.classList.add('is-open');
        document.body.classList.add('gallery-modal-open');

        $(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            speed: 300,
            initialSlide: index,
            adaptiveHeight: false,
        });

        // off antes: o modal reabre no mesmo slider e o handler acumulava a cada abertura
        $(slider).off('afterChange').on('afterChange', function (event, slick, currentSlide) {
            zoomOut();
            resetPinch();
            // pausa qualquer vídeo que ficou para trás
            slider.querySelectorAll('video').forEach(video => video.pause());
            updateStatus(currentSlide, items.length);
        });

        updateStatus(index, items.length);
    }

    function closeModal() {
        if (!modal) return;

        zoomOut();
        resetPinch();
        modal.classList.remove('is-open');
        document.body.classList.remove('gallery-modal-open');

        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('unslick');
        }

        // limpar o conteúdo interrompe vídeos e iframes que estavam tocando
        slider.innerHTML = '';
    }

    function sourceOf(element) {
        return element.getAttribute('href') || element.getAttribute('data-gallery-src');
    }

    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-gallery]');
        if (!trigger) return;

        // os vídeos entram na galeria, mas tocam na própria página:
        // só os links (imagens) abrem o modal
        if (!trigger.getAttribute('href')) return;

        e.preventDefault();

        const group = trigger.getAttribute('data-gallery');
        // o slick duplica slides quando é infinito; os clones não podem entrar na lista
        const members = Array.from(document.querySelectorAll(`[data-gallery="${group}"]`))
            .filter(item => sourceOf(item) && !item.closest('.slick-cloned'));

        const items = members.map(item => ({
            src: sourceOf(item),
            type: item.getAttribute('data-gallery-type') || ''
        }));

        let index = members.indexOf(trigger);
        if (index < 0) {
            // clicou num clone: localiza pela imagem correspondente
            index = Math.max(items.findIndex(item => item.src === sourceOf(trigger)), 0);
        }

        if (items.length) openModal(items, index);
    });
})();
